var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Admin Languages","fields":_vm.fields,"response":_vm.data},on:{"delete":_vm.deleteLanguage,"create":_vm.createLanguage,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }